import { defineStore } from "pinia";
import { useStorage, useSessionStorage } from '@vueuse/core';

export const useUserStore = defineStore("UserStore", () => {
  const data = useSessionStorage('user', {});
  const levelSelected = useSessionStorage('levelSelected', 0);
  const hash = useSessionStorage('hash', {});

  return { data, levelSelected, hash };
});
